import React from "react";
import {
  ProgramMentorsContainer,
  MentorCard,
  MentorImage,
  MentorInfo,
  MentorName,
  MentorBio,
  Actions,
} from "./styles";
import callAPI from "../../../../../api/apiCaller";
import Loading from "../../../../../common/Loading";
import Button from "../../../../../common/Button";
import { useNavigate } from "react-router-dom";
import { ButtonSpacer } from "../../../../../common/Button/styles";
import { Context } from "../../../../../Store";
import { getUserInfo } from "../../../../../Store/User/accessors";
import { formatDescription } from "../../../../../common/utils";

function ProgramMentors({ program }) {
  const [mentors, setMentors] = React.useState(null);
  const [isRequesting, setIsRequesting] = React.useState(false);
  const navigate = useNavigate();
  const { state, dispatch } = React.useContext(Context);
  const userData = getUserInfo(state);
  React.useState(() => {
    callAPI(dispatch, "getProgramMentors", program).then((response) => {
      setMentors(response);
    });
  }, []);
  function requestMentorship(id) {
    setIsRequesting(id);
    callAPI(dispatch, "requestMentorship").then((response) => {
      setMentors(response);
      setIsRequesting(false);
    });
  }
  if (mentors === null) {
    return <Loading loadingItem="All Mentors" />;
  }
  return (
    <ProgramMentorsContainer>
      {mentors.map((mentor) => (
        <MentorCard>
          <MentorImage src={mentor.image} />
          <MentorInfo>
            <MentorName>{mentor.name}</MentorName>
            <MentorBio>{formatDescription(mentor.bio)}</MentorBio>
            <Actions>
              {mentor.id !== userData.id && (
                <Button
                  text="Message"
                  icon="chat"
                  onClick={() => {
                    callAPI(dispatch, "initializeConversation", {
                      id: mentor.id,
                    })
                      .then((res) => {
                        if (res) {
                          navigate("/messages/" + mentor.uuid);
                        }
                      })
                      .catch((error) => {
                        console.error(error);
                      });
                  }}
                />
              )}
              {program.role === "mentee" && (
                <>
                  <ButtonSpacer />
                  <Button
                    text={
                      mentor.status === "not-connected"
                        ? "Request Mentorship"
                        : mentor.status === "requested"
                        ? "Request Pending"
                        : "Already Connected"
                    }
                    icon={
                      isRequesting === mentor.id
                        ? "loading"
                        : mentor.status === "connected"
                        ? "tick"
                        : mentor.status === "not-connected"
                        ? "send"
                        : "time"
                    }
                    variant="primary"
                    disabled={mentor.status !== "not-connected"}
                    onClick={() => {
                      requestMentorship(mentor.id);
                    }}
                  />
                </>
              )}
            </Actions>
          </MentorInfo>
        </MentorCard>
      ))}
    </ProgramMentorsContainer>
  );
}
export default ProgramMentors;
